export function isAsyncData(data) {
  return data.hasAsyncChildren ?? false;
}